"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TokenIcon = ({ tokenInfo, width = 24, height = 24, }) => {
    const [error, setError] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-xs flex items-center justify-center rounded-full overflow-hidden", style: { width, height }, children: tokenInfo && !error ? (
        // eslint-disable-next-line @next/next/no-img-element
        (0, jsx_runtime_1.jsx)("img", { onError: () => setError(true), src: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.logoURI, alt: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol, width: width, height: height })) : ((0, jsx_runtime_1.jsx)("div", { className: "items-center justify-center rounded-full overflow-hidden bg-black/20", style: { width, height } })) }));
};
exports.default = TokenIcon;
